import { GET, POST, PUT, DELETE } from "../../api";

export const findAll = async (searchDateFrom, searchDateTo) => {
  return await GET(
    `/admin/dashboard?from=${searchDateFrom || ""}&to=${searchDateTo || ""}`
  );
};

export const findAllSideBar = async () => {
  return await GET(`/admin/dashboard/sidebar`);
};
